import { DocumentData } from "firebase-admin/firestore";
import { CollectionName, CollectionStateModel } from "./collection-model.interface";

export namespace Collection {
  export class Fetch<T extends CollectionName> {
    static readonly type = "[CollectionState] Fetch";
    constructor(
      public collectionName: T,
      public startAfterDoc: DocumentData | null = null
    ) {}
  }

  export class SetCollection<T extends CollectionName> {
    static readonly type = "[CollectionState] Set Collection";
    constructor(
      public collectionName: T,
      public data: CollectionStateModel[T]
    ) {}
  }
}
